import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Lock } from 'lucide-react'

const ContactAdmin = ({ description }: { description: string }) => {
	return (
		<div className="flex bg-background">
			<Card className="w-full max-w-sm mx-4">
				<CardHeader>
					<CardTitle className="flex items-center gap-2">
						<Lock className="w-5 h-5" />
						Feature Unavailable
					</CardTitle>
				</CardHeader>
				<CardContent>
					<p className="text-muted-foreground">{description}</p>
					<p className="text-muted-foreground mt-4">Please contact your administrator for access.</p>
				</CardContent>
			</Card>
		</div>
	)
}

export default ContactAdmin
